
export default {
	props: {
		closable: {
			default: true,
			type: Boolean,
		},
		showModal: {
			type: Boolean,
			required: true,
		},
		width: String,
		height: String,
	},
	data() {
		return {
			show: false,
		}
	},
	watch: {
		showModal: {
			handler(newValue) {
				this.show = newValue
			},
			immediate: true,
		},
	},
	methods: {
		closeModal() {
			if (this.closable) {
				this.show = false
				this.$emit('close')
			}
		},
		modalClicked() {
			this.$emit('click:modal')
		},
	},
}
